module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('v-btn', {
    class: {
      blue: _vm.englishForAll
    },
    on: {
      "click": function($event) {
        return _vm.setAllToEnglish()
      }
    }
  }, [_vm._v("Take over english for all")]), _vm._v(" "), (_vm.englishForAll === false) ? _c('div', _vm._l((_vm.languages), function(language, code) {
    return _c('div', {
      key: code
    }, [_c('v-text-field', {
      ref: code,
      refInFor: true,
      attrs: {
        "label": language,
        "value": _vm.getText(code),
        "hint": _vm.getHint(code),
        "multi-line": _vm.isMultiline,
        "persistent-hint": ""
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.englishForAll === true) ? _c('div', _vm._l((_vm.languages), function(language, code) {
    return _c('div', {
      key: code
    }, [_c('v-text-field', {
      ref: code,
      refInFor: true,
      attrs: {
        "label": language,
        "value": (_vm.$refs['en'][0].value !== _vm.$refs['en'][0].lazyValue) ? _vm.$refs['en'][0].lazyValue : _vm.$refs['en'][0].value,
        "hint": _vm.getHint(code),
        "multi-line": _vm.isMultiline,
        "persistent-hint": ""
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "success": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("save")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-2a6e49cc"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsI18nDialog.vue
// module id = 927
// module chunks = 1